import type { IxcGenerateV1MonthlyStatementsTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DOCGEN_MONTHLY_STATEMENT_TASK_BASE_PATH = getResolvedPath('/clearing/operations/generate/monthly-statement/task');

export const getDocgenMonthlyStatementTaskPath: EntityPathBuilder<IxcGenerateV1MonthlyStatementsTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DOCGEN_MONTHLY_STATEMENT_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${DOCGEN_MONTHLY_STATEMENT_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getDocgenMonthlyStatementTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getDocgenMonthlyStatementTaskPath({ kind: 'detail', keys: { taskId } });
}
